import authService from "../api/index";
export const NAMESPACE = "authModule";

const services = {
  api: authService
};
const state = {
  groups: [],
  allGroups: []
};
const actions = {
  GET_GROUPS(context, data) {
    return services.api.getGroups().then(function(value) {
      context.commit("SET_GROUPS", value);
    });
  },
  CHECK_ROLES(context, data) {
    // -- check user role
    if (!context.state.groups) {
      return actions.GET_GROUPS(context, data).then(res => {
        return Promise.resolve(context.getters.isAllowedRole(data));
      });
    } else return Promise.resolve(context.getters.isAllowedRole(data));
  }
};
const mutations = {
  SET_GROUPS(storeState, data) {
    storeState.groups = data.userGroups.map(function(x) {
      return x.id;
    });
    storeState.allGroups = data.allGroups;
  }
};
const getters = {
  groups: storeState => storeState.groups,
  allGroups: storeState => storeState.allGroups,
  isAllowedRole: storeState => roles => {
    if (!roles) return true;
    if (!storeState.groups) return false;
    return storeState.groups.some(function(v) {
      return !roles || roles.indexOf(v) >= 0;
    });
  }
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
  services
};
